const DEFAULT_CACHE_EXPIRY_MS = 30 * 60 * 1000; // Default: 30 minutes

type StorageType = "local" | "session";

class CacheService {
  static setItem(
    key: string,
    value: any,
    storageType: StorageType = "local",
    withExpiry: boolean = true,
    expireTime: number = DEFAULT_CACHE_EXPIRY_MS
  ) {
    const storage = storageType === "local" ? localStorage : sessionStorage;
    const data = withExpiry
      ? { value, expiry: Date.now() + expireTime }
      : { value };

    storage.setItem(key, JSON.stringify(data));
  }

  static getItem<T>(
    key: string,
    storageType: StorageType = "local",
    withExpiry: boolean = true
  ): T | null {
    const storage = storageType === "local" ? localStorage : sessionStorage;
    const cachedData = storage.getItem(key);

    if (!cachedData) return null;

    const parsedData = JSON.parse(cachedData);

    if (withExpiry && parsedData.expiry && Date.now() > parsedData.expiry) {
      storage.removeItem(key);
      return null;
    }

    return parsedData.value as T;
  }

  static removeItem(key: string, storageType: StorageType = "local") {
    const storage = storageType === "local" ? localStorage : sessionStorage;
    storage.removeItem(key);
  }

  static clearAll(storageType: StorageType = "local") {
    const storage = storageType === "local" ? localStorage : sessionStorage;
    storage.clear();
  }
}

export default CacheService;
